/**
 * @generated SignedSource<<d6f9c9db6f22b286c7fe18a695b1a989>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpcomingEventsClub_club$data = {
  readonly copyOverrides: {
    readonly event: {
      readonly plural: string;
    } | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly upcomingEvents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly startOn: string;
        readonly " $fragmentSpreads": FragmentRefs<"NewPatronEventCardWrapper">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
    };
  } | null | undefined;
  readonly " $fragmentType": "UpcomingEventsClub_club";
};
export type UpcomingEventsClub_club$key = {
  readonly " $data"?: UpcomingEventsClub_club$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpcomingEventsClub_club">;
};

import UpcomingEventsClubQuery_graphql from './UpcomingEventsClubQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "upcomingEvents"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "count"
    },
    {
      "kind": "RootArgument",
      "name": "cursor"
    },
    {
      "kind": "RootArgument",
      "name": "endDate"
    },
    {
      "kind": "RootArgument",
      "name": "eventTags"
    },
    {
      "kind": "RootArgument",
      "name": "memberId"
    },
    {
      "kind": "RootArgument",
      "name": "search"
    },
    {
      "kind": "RootArgument",
      "name": "startDate"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": UpcomingEventsClubQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "UpcomingEventsClub_club",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ClubCopyOverrides",
      "kind": "LinkedField",
      "name": "copyOverrides",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NounOverride",
          "kind": "LinkedField",
          "name": "event",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plural",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "upcomingEvents",
      "args": [
        {
          "kind": "Variable",
          "name": "dateGte",
          "variableName": "startDate"
        },
        {
          "kind": "Variable",
          "name": "dateLte",
          "variableName": "endDate"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        },
        {
          "kind": "Variable",
          "name": "tagIds",
          "variableName": "eventTags"
        }
      ],
      "concreteType": "EventConnection",
      "kind": "LinkedField",
      "name": "__UpcomingEventsClub_upcomingEvents_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Event",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startOn",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NewPatronEventCardWrapper"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "Club",
  "abstractKey": null
};
})();

(node as any).hash = "7662de4a48de82265b57550b259086fc";

export default node;
